const PLACEMENT_ENUMS = {
  "TOP-START": "top-start",
  TOP: "top",
  "TOP-END": "top-end",
  "BOTTOM-START": "bottom-start",
  BOTTOM: "bottom",
  "BOTTOM-END": "bottom-end",
  "LEFT-START": "left-start",
  LEFT: "left",
  "LEFT-END": "left-end",
  "RIGHT-START": "right-start",
  RIGHT: "right",
  "RIGHT-END": "right-end"
};
export {
  PLACEMENT_ENUMS
};
//# sourceMappingURL=constants.mjs.map
